import Joi from "joi";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import Toast from "../../helpers/Toast";
import { IHolidayDTO } from "../../models/Holiday/Iholidaydto";
import { IHolidayCreateDTO } from "../../models/Holiday/iholidaycreatedto";
import { HolidayService } from "../../services/HolidayService";
import useValidationSchema, {FieldConfig} from "../../components/Validations";

export default function HolidayCreate() {
    const intl = useIntl();
    const holidayService = new HolidayService();
    const [loadingCreate, setLoadingCreate] = useState<boolean>(false);
    const [Holiday, setHoliday] = useState<IHolidayDTO | null>(null);

    const navigate = useNavigate();

    const fields: FieldConfig[] = [
        ["name", "string", "Screens.Holiday.Validation.NameRequired"],
        ["date", "date", "Screens.Holiday.Validation.dateRequired"],
    ];

    const schemaClientValidation = useValidationSchema(fields);

    const createHoliday = async () => {
        setLoadingCreate(true); 
    
        const { error } = schemaClientValidation.validate(Holiday);
        
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setLoadingCreate(false); 
            return;
        }
    
        if (!Holiday) {
            Toast.Show("error", intl.formatMessage({ id: "Screens.Holiday.Validation.HolidayRequired" }));
            setLoadingCreate(false);
            return;
        }

        const createHoliday: IHolidayCreateDTO = {
            name: Holiday.name,
            date: Holiday.date
        };
    
        const response = await holidayService.Create(createHoliday);
    
        if (response.success !== true) {
            Toast.Show("error", response.message);
            setLoadingCreate(false); 
            return;
        }
    
        Toast.Show("success", response.message);
        setLoadingCreate(false); 
        navigate(-1); 
    };      

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <PageTitle title={intl.formatMessage({ id: "Screens.Holiday.CreateTitle" })} allowGoBack={true} />
                </div>
                <div className="pageBody">
                    <Row className="g-0" style={{  }}>
                        <Col lg={6} >
                            <InputComponent
                                type={"text"}
                                value={Holiday?.name}
                                label={intl.formatMessage({ id: "Screens.Holiday.Info.Name" })}
                                readOnly={false}
                                lg={12}
                                style={{ width: "80%", borderRadius: "8px" }}
                                onChange={(t: string) => {
                                    setHoliday({ ...Holiday, name: t } as IHolidayDTO)
                                }}
                            />
                        </Col>
                        <Col lg={6} >
                            <InputComponent
                                type={"date"}
                                value={Holiday?.date ? Holiday.date.toISOString().split('T')[0] : undefined}
                                label={intl.formatMessage({ id: "Screens.Holiday.Info.Date" })}
                                readOnly={false}
                                lg={12}
                                onChange={(t: string) => {
                                    setHoliday({ ...Holiday, date: new Date(t) } as IHolidayDTO)
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className="g-0" style={{ margin: 0, marginTop: "10px" }}>
                        <Col style={{ margin: 0, padding: 0 }}>
                            <ButtonComponent
                                disabled={loadingCreate}
                                loading={loadingCreate}
                                text={intl.formatMessage({ id: "Gravar" })}
                                onClick={() => createHoliday()}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </Layout>
    );
}
